import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import MarkdownContainer from '../../atoms/MarkdownContainer/MarkdownContainer';
import { parseFontAwesomeClass } from '../../../utils/fontawesome/config';
import { hasCellContent } from '../../../domain/checkboxList/checkboxListUseCase';
import cn from '../../../utils/cn';

import styles from './CheckboxOptionLabel.module.css';

/**
 * Renders a horizontal row of display cells for a checkbox option label.
 * @param {object} props
 * @param {CheckboxListCell[]} [props.cells]
 * @param {string} [props.className]
 * @returns {JSX.Element | null}
 */
function CheckboxOptionLabel({ cells = [], className = '' }) {
  const items = Array.isArray(cells) ? cells.filter(hasCellContent) : [];

  if (items.length === 0) return null;

  return (
    <span className={cn([styles.wrapper, className])}>
      {items.map((cell, index) => {
        const iconDefinition = cell.icon ? parseFontAwesomeClass(cell.icon) : null;
        const iconColor = cell.iconColor || undefined;
        const backgroundColor = cell.backgroundColor || 'transparent';
        const openTabUrl = cell.openTabUrl || '';

        const content = (
          <>
            {iconDefinition ? (
              <FontAwesomeIcon
                icon={/** @type {any} */ (iconDefinition)}
                style={iconColor ? { color: iconColor } : undefined}
              />
            ) : null}
            {cell.imageUrl ? (
              <img
                src={cell.imageUrl}
                alt=""
                className={styles.image}
              />
            ) : null}
            {cell.lib ? (
              <MarkdownContainer
                content={cell.lib}
                className={styles.label}
                as="span"
              />
            ) : null}
          </>
        );

        const containerClassName = cn([
          styles.cell,
          backgroundColor !== 'transparent' && styles['cell-with-background'],
        ]);

        const key = `${cell.lib || ''}-${cell.icon || ''}-${cell.imageUrl || ''}-${index}`;

        if (openTabUrl) {
          return (
            <a
              key={key}
              href={openTabUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={containerClassName}
              style={{ color: iconColor, backgroundColor }}
              onClick={(e) => e.stopPropagation()}
            >
              {content}
            </a>
          );
        }

        return (
          <span
            key={key}
            className={containerClassName}
            style={{ color: iconColor, backgroundColor }}
          >
            {content}
          </span>
        );
      })}
    </span>
  );
}

export default CheckboxOptionLabel;
